import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=7bb3a84e&"
import script from "./statistics.vue?vue&type=script&lang=ts&"
export * from "./statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports